import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);
const API_URL = "/heroes";

// ========== ADMIN ROUTES ==========

// Lấy tất cả hero sections cho admin (hoặc filter theo page)
export const getHeroForAdmin = async (page = null) => {
    try {
        const params = page ? { page } : {};
        const response = await apiClient.get(`${API_URL}/admin`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching hero for admin:', error);
        throw error;
    }
};

// Tạo hero section mới
export const createHero = async (data) => {
    try {
        const response = await apiClient.post(`${API_URL}/admin`, data);
        return response.data;
    } catch (error) {
        console.error('Error creating hero:', error);
        throw error;
    }
};

// Cập nhật hero section
export const updateHero = async (id, data) => {
    try {
        const response = await apiClient.put(`${API_URL}/admin/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating hero:', error);
        throw error;
    }
};

// Xóa hero section
export const deleteHero = async (id) => {
    try {
        const response = await apiClient.delete(`${API_URL}/admin/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting hero:', error);
        throw error;
    }
};

// ========== CUSTOMER ROUTES ==========

// Lấy hero section cho khách hàng theo trang
export const getHeroForCustomer = async (page) => {
    try {
        const response = await apiClient.get(`${API_URL}/customer/${page}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching hero for customer:', error);
        throw error;
    }
};

// Lấy tất cả hero sections cho khách hàng
export const getAllHeroForCustomer = async () => {
    try {
        const response = await apiClient.get(`${API_URL}/customer`);
        return response.data;
    } catch (error) {
        console.error('Error fetching all heroes for customer:', error);
        throw error;
    }
};